export const toArray = (data) => {
  if (!data) return [];
  if (Array.isArray(data)) return data;
  if (Array.isArray(data.items)) return data.items;
  if (Array.isArray(data.data)) return data.data;
  return [];
};

export const money = (value) => `Rs ${Number(value || 0).toLocaleString('en-IN')}`;

export const percent = (score, total) => total > 0 ? Number(((score / total) * 100).toFixed(1)) : 0;

export const grade = (value) => {
  if (value >= 90) return { label: 'A+', color: 'text-emerald-600', bg: 'bg-emerald-100' };
  if (value >= 80) return { label: 'A', color: 'text-green-600', bg: 'bg-green-100' };
  if (value >= 70) return { label: 'B', color: 'text-sky-600', bg: 'bg-sky-100' };
  if (value >= 60) return { label: 'C', color: 'text-amber-600', bg: 'bg-amber-100' };
  return { label: 'F', color: 'text-rose-600', bg: 'bg-rose-100' };
};

export const downloadCsv = (name, rows) => {
  if (!rows.length) return;
  const headers = Object.keys(rows[0]);
  const escape = (value) => `"${String(value ?? '').replaceAll('"', '""')}"`;
  const csv = [headers.join(','), ...rows.map((row) => headers.map((header) => escape(row[header])).join(','))].join('\n');
  const blob = new Blob([csv], { type: 'text/csv;charset=utf-8;' });
  const url = URL.createObjectURL(blob);
  const link = document.createElement('a');
  link.href = url;
  link.download = name;
  document.body.appendChild(link);
  link.click();
  link.remove();
  URL.revokeObjectURL(url);
};

export const parseCsv = (text) => {
  const [headerLine, ...lines] = text.trim().split(/\r?\n/);
  if (!headerLine) return [];
  const headers = headerLine.split(',').map((item) => item.trim());
  return lines.filter(Boolean).map((line) => {
    const values = line.split(',').map((item) => item.trim());
    return headers.reduce((row, header, index) => ({ ...row, [header]: values[index] || '' }), {});
  });
};

export const qrImage = (text) => `https://api.qrserver.com/v1/create-qr-code/?size=180x180&data=${encodeURIComponent(text)}`;

export const dateOnly = (value) => value ? String(value).split('T')[0] : '-';
